import React from "react";

export default function NZNoticeModal() {
  return null;
}
